module.exports = __webpack_public_path__ + "assets/img/driver-btn-59d727a4.png";